// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// ILendingPoolAddressesProvider https://etherscan.io/address/0xB53C1a33016B2DC2fF3653530bfF1848a515c8c5
export const POOL_ADDRESSES_PROVIDER = '0xB53C1a33016B2DC2fF3653530bfF1848a515c8c5';

// ILendingPool https://etherscan.io/address/0x7d2768dE32b0b80b7a3454c06BdAc94A69DDc7A9
export const POOL = '0x7d2768dE32b0b80b7a3454c06BdAc94A69DDc7A9';

// https://etherscan.io/address/0x02D84abD89Ee9DB409572f19B6e1596c301F3c81
export const POOL_IMPL = '0x02D84abD89Ee9DB409572f19B6e1596c301F3c81';

// ILendingPoolConfigurator https://etherscan.io/address/0x311Bb771e4F8952E6Da169b425E7e92d6Ac45756
export const POOL_CONFIGURATOR = '0x311Bb771e4F8952E6Da169b425E7e92d6Ac45756';

// https://etherscan.io/address/0x246ca67522dF5895cD6cf8807Ec161954ea1bA61
export const POOL_CONFIGURATOR_IMPL = '0x246ca67522dF5895cD6cf8807Ec161954ea1bA61';

// IAaveOracle https://etherscan.io/address/0xA50ba011c48153De246E5192C8f9258A2ba79Ca9
export const ORACLE = '0xA50ba011c48153De246E5192C8f9258A2ba79Ca9';

// ILendingRateOracle https://etherscan.io/address/0x8A32f49FFbA88aba6EFF96F45D8BD1D4b3f35c7D
export const LENDING_RATE_ORACLE = '0x8A32f49FFbA88aba6EFF96F45D8BD1D4b3f35c7D';

// IAaveProtocolDataProvider https://etherscan.io/address/0x057835Ad21a177dbdd3090bB1CAE03EaCF78Fc6d
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x057835Ad21a177dbdd3090bB1CAE03EaCF78Fc6d';

// https://etherscan.io/address/0xcc9632725266473ab5d42320E8Ae00437A1df3bB
export const LENDING_POOL_COLLATERAL_MANAGER = '0xcc9632725266473ab5d42320E8Ae00437A1df3bB';

// https://etherscan.io/address/0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A
export const POOL_ADMIN = '0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A';

// https://etherscan.io/address/0x2CFe3ec4d5a6811f4B8067F0DE7e47DfA938Aa30
export const EMERGENCY_ADMIN = '0x2CFe3ec4d5a6811f4B8067F0DE7e47DfA938Aa30';

// ICollector https://etherscan.io/address/0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c
export const COLLECTOR = '0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c';

// https://etherscan.io/address/0xd784927Ff2f95ba542BfC824c8a8a98F3495f6b5
export const DEFAULT_INCENTIVES_CONTROLLER = '0xd784927Ff2f95ba542BfC824c8a8a98F3495f6b5';

// https://etherscan.io/address/0xEE56e2B3D491590B5b31738cC34d5232F378a8D5
export const EMISSION_MANAGER = '0xEE56e2B3D491590B5b31738cC34d5232F378a8D5';

// https://etherscan.io/address/0xAf5c88245CD02Ff3DF332EF1E1FfD5bc5D1d87cd
export const DEBT_SWAP_ADAPTER = '0xAf5c88245CD02Ff3DF332EF1E1FfD5bc5D1d87cd';

// https://etherscan.io/address/0x9eCed0293e7B73CFf4a2b4F9C82aAc8346158bd9
export const CONFIG_ENGINE = '0x9eCed0293e7B73CFf4a2b4F9C82aAc8346158bd9';

// https://etherscan.io/address/0xd417D34D7aAf70B24FbC6b36808E3396c991C5e4
export const MIGRATION_HELPER = '0xd417D34D7aAf70B24FbC6b36808E3396c991C5e4';

// https://etherscan.io/address/0x52D306e36E3B6B02c153d0266ff0f85d18BCD413
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x52D306e36E3B6B02c153d0266ff0f85d18BCD413';

// https://etherscan.io/address/0xbD37610BBB1ddc2a22797F7e3f531B59902b7bA7
export const RATES_FACTORY = '0xbD37610BBB1ddc2a22797F7e3f531B59902b7bA7';

// https://etherscan.io/address/0x80Aca0C645fEdABaa20fd2Bf0Daf57885A309FE6
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x80Aca0C645fEdABaa20fd2Bf0Daf57885A309FE6';

// https://etherscan.io/address/0x135896DE8421be2ec868E0b811006171D9df802A
export const SWAP_COLLATERAL_ADAPTER = '0x135896DE8421be2ec868E0b811006171D9df802A';

// https://etherscan.io/address/0xD01ab9a6577E1D84F142e44D49380e23A340387d
export const UI_INCENTIVE_DATA_PROVIDER = '0xD01ab9a6577E1D84F142e44D49380e23A340387d';

// https://etherscan.io/address/0x00e50FAB64eBB37b87df06Aa46b8B35d5f1A4e1A
export const UI_POOL_DATA_PROVIDER = '0x00e50FAB64eBB37b87df06Aa46b8B35d5f1A4e1A';

// https://etherscan.io/address/0x8E8dAd5409E0263a51C0aB5055dA66Be28cFF922
export const WALLET_BALANCE_PROVIDER = '0x8E8dAd5409E0263a51C0aB5055dA66Be28cFF922';

// https://etherscan.io/address/0xa0d9C1E9E48Ca30c8d8C3B5D69FF5dc1f6DFfC24
export const WETH_GATEWAY = '0xa0d9C1E9E48Ca30c8d8C3B5D69FF5dc1f6DFfC24';

// https://etherscan.io/address/0x6A14eBe9A934c8EFE15C3811a999149472876b56
export const CLINIC_STEWARD = '0x6A14eBe9A934c8EFE15C3811a999149472876b56';

export const CHAIN_ID = 1;
export const ASSETS = {
  USDT: {
    decimals: 6,
    id: 0,
    UNDERLYING: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    A_TOKEN: '0x3Ed3B47Dd13EC9a98b44e6204A523E766B225811',
    V_TOKEN: '0x531842cEbbdD378f8ee36D171d6cC9C4fcf475Ec',
    INTEREST_RATE_STRATEGY: '0x8A50d613d683c1c381aA027c4d922aE55Fd8A3B3',
    ORACLE: '0xCB45B5c861a6468145b1720A620C38f55f736B74',
  },
  WBTC: {
    decimals: 8,
    id: 1,
    UNDERLYING: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    A_TOKEN: '0x9ff58f4fFB29fA2266Ab25e75e2A8b3503311656',
    V_TOKEN: '0x9c39809Dec7F95F5e0713634a4D0701329B3b4d2',
    INTEREST_RATE_STRATEGY: '0xdbcea77E2C4A0e6158a7555C249f28A8Da449178',
    ORACLE: '0xFD858c8bC5ac5e10f01018bC78471bb0DC392247',
  },
  WETH: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    A_TOKEN: '0x030bA81f1c18d280636F32af80b9AAd02Cf0854e',
    V_TOKEN: '0xF63B34710400CAd3e044cFfDcAb00a0f32E33eCf',
    INTEREST_RATE_STRATEGY: '0x2D8A2d50D3158085180D32A9C0655b13bce81f22',
    ORACLE: '0x0000000000000000000000000000000000000000',
  },
  YFI: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
    A_TOKEN: '0x5165d24277cD063F5ac44Efd447B27025e888f37',
    V_TOKEN: '0x7EbD09022Be45AD993BAA1CEc61166Fcc8644d97',
    INTEREST_RATE_STRATEGY: '0x2c206fa2127aB7f1CE3dc987daf683Ed5B9CF069',
    ORACLE: '0x7c5d4F8345e66f68099581Db340cd65B078C41f4',
  },
  ZRX: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0xE41d2489571d322189246DaFA5ebDe1F4699F498',
    A_TOKEN: '0xDf7FF54aAcAcbFf42dfe29DD6144A69b629f8C9e',
    V_TOKEN: '0x85791D117A392097590bDeD3bD5abB8d5A20491A',
    INTEREST_RATE_STRATEGY: '0x91773a61759398d33C252F25A38DA77a51e0c9Ff',
    ORACLE: '0x2Da4983a622a8498bb1a21FaE9D8F6C664939962',
  },
  UNI: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
    A_TOKEN: '0xB9D7CB55f463405CDfBe4E90a6D2Df01C2B92BF1',
    V_TOKEN: '0x5BdB050A92CADcCfCDcCCBFC17204a1C9cC0Ab73',
    INTEREST_RATE_STRATEGY: '0x87cCa171a2125efca9868F9Bc1FfD7B7c80dC5a3',
    ORACLE: '0xD6aA3D25116d8dA79Ea0246c4826EB951872e02e',
  },
  AAVE: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
    A_TOKEN: '0xFFC97d72E13E01096502Cb8Eb52dEe56f74DAD7B',
    V_TOKEN: '0xF7DBA49d571745D9d7fcb56225B05BEA803EBf3C',
    INTEREST_RATE_STRATEGY: '0xd4cA26F2496195C4F886D464D8578368236bB747',
    ORACLE: '0x6Df09E975c830ECae5bd4eD9d90f3A95a4f88012',
  },
  BAT: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0x0D8775F648430679A709E98d2b0Cb6250d2887EF',
    A_TOKEN: '0x05Ec93c0365baAeAbF7AefFb0972ea7ECdD39CF1',
    V_TOKEN: '0xfc218A6Dfe6901CB34B1a5281FC6f1b8e7E56877',
    INTEREST_RATE_STRATEGY: '0x91773a61759398d33C252F25A38DA77a51e0c9Ff',
    ORACLE: '0x0d16d4528239e9ee52fa531af613AcdB23D88c94',
  },
  BUSD: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0x4Fabb145d64652a948d72533023f6E7A623C7C53',
    A_TOKEN: '0xA361718326c15715591c299427c62086F69923D9',
    V_TOKEN: '0xbA429f7011c9fa04cDd46a2Da24dc0FF0aC6099c',
    INTEREST_RATE_STRATEGY: '0x2821B41F1fA07c0270A3f0de91B24B9766F312FD',
    ORACLE: '0x190be7269f53b4C3d8057b8c7a058A750ded1356',
  },
  DAI: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    A_TOKEN: '0x028171bCA77440897B824Ca71D1c56caC55b68A3',
    V_TOKEN: '0x6C3c78838c761c6Ac7bE9F59fe808ea2A6E4379d',
    INTEREST_RATE_STRATEGY: '0x54bE9DB9E111EBCe28c702825154f8c49e1eE93E',
    ORACLE: '0x53a7856Cb3092E9c7C2c50e05E5b24462B7B9698',
  },
  ENJ: {
    decimals: 18,
    id: 10,
    UNDERLYING: '0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c',
    A_TOKEN: '0xaC6Df26a590F08dcC95D5a4705ae8abbc88509Ef',
    V_TOKEN: '0x38995F292a6E31b78203254fE1cdd5Ca1010A446',
    INTEREST_RATE_STRATEGY: '0x2c206fa2127aB7f1CE3dc987daf683Ed5B9CF069',
    ORACLE: '0x24D9aB51950F3d62E9144fdC2f3135DAA6Ce8D1B',
  },
  KNC: {
    decimals: 18,
    id: 11,
    UNDERLYING: '0xdd974D5C2e2928deA5F71b9825b8b646686BD200',
    A_TOKEN: '0x39C6b3e42d6A679d7D776778Fe880BC9487C2EDA',
    V_TOKEN: '0x6B05D1c608015Ccb8e205A690cB86773A96F39f1',
    INTEREST_RATE_STRATEGY: '0x2c206fa2127aB7f1CE3dc987daf683Ed5B9CF069',
    ORACLE: '0x656c0544eF4C98A6a98491833A89204Abb045d6b',
  },
  LINK: {
    decimals: 18,
    id: 12,
    UNDERLYING: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    A_TOKEN: '0xa06bC25B5805d5F8d82847D191Cb4Af5A3e873E0',
    V_TOKEN: '0x0b8f12b1788BFdE65Aa1ca52E3e9F3Ba401be16D',
    INTEREST_RATE_STRATEGY: '0x2c206fa2127aB7f1CE3dc987daf683Ed5B9CF069',
    ORACLE: '0xDC530D9457755926550b59e8ECcdaE7624181557',
  },
  MANA: {
    decimals: 18,
    id: 13,
    UNDERLYING: '0x0F5D2fB29fb7d3CFeE444a200298f468908cC942',
    A_TOKEN: '0xa685a61171bb30d4072B338c80Cb7b2c865c873E',
    V_TOKEN: '0x0A68976301e46Ca6Ce7410DB28883E309EA0D352',
    INTEREST_RATE_STRATEGY: '0x91773a61759398d33C252F25A38DA77a51e0c9Ff',
    ORACLE: '0x82A44D92D6c329826dc557c5E1Be6ebeC5D5FeB9',
  },
  MKR: {
    decimals: 18,
    id: 14,
    UNDERLYING: '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2',
    A_TOKEN: '0xc713e5E149D5D0715DcD1c156a020976e7E56B88',
    V_TOKEN: '0xba728eAd5e496BE00DCF66F650b6d7758eCB50f8',
    INTEREST_RATE_STRATEGY: '0x2c206fa2127aB7f1CE3dc987daf683Ed5B9CF069',
    ORACLE: '0x24551a8Fb2A7211A25a17B1481f043A8a8adC7f2',
  },
  REN: {
    decimals: 18,
    id: 15,
    UNDERLYING: '0x408e41876cCCDC0F92210600ef50372656052a38',
    A_TOKEN: '0xCC12AbE4ff81c9378D670De1b57F8e0Dd228D77a',
    V_TOKEN: '0xcd9D82d33bd737De215cDac57FE2F7f04DF77FE0',
    INTEREST_RATE_STRATEGY: '0x2c206fa2127aB7f1CE3dc987daf683Ed5B9CF069',
    ORACLE: '0x3147D7203354Dc06D9fd350c7a2437bcA92387a4',
  },
  SNX: {
    decimals: 18,
    id: 16,
    UNDERLYING: '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
    A_TOKEN: '0x35f6B052C598d933D69A4EEC4D04c73A191fE6c2',
    V_TOKEN: '0x267EB8Cf715455517F9BD5834AeAE3CeA1EBdbD8',
    INTEREST_RATE_STRATEGY: '0x6855E5544Cd803BF24c9612b3F12C009116B0ee1',
    ORACLE: '0x79291A9d692Df95334B1a0B3B4AE6bC606782f8c',
  },
  sUSD: {
    decimals: 18,
    id: 17,
    UNDERLYING: '0x57Ab1ec28D129707052df4dF418D58a2D46d5f51',
    A_TOKEN: '0x6C5024Cd4F8A59110119C56f8933403A539555EB',
    V_TOKEN: '0xdC6a3Ab17299D9C2A412B0e0a4C1f55446AE0817',
    INTEREST_RATE_STRATEGY: '0x6855E5544Cd803BF24c9612b3F12C009116B0ee1',
    ORACLE: '0xC3c79aa824373c793E60901428e11884BFeD83Ed',
  },
  TUSD: {
    decimals: 18,
    id: 18,
    UNDERLYING: '0x0000000000085d4780B73119b644AE5ecd22b376',
    A_TOKEN: '0x101cc05f4A51C0319f570d5E146a8C625198e636',
    V_TOKEN: '0x01C0eb1f8c6F1C1bF74ae028697ce7AA2a8b0E92',
    INTEREST_RATE_STRATEGY: '0x2821B41F1fA07c0270A3f0de91B24B9766F312FD',
    ORACLE: '0x34A99cE5B513Baa1e27af7eED8E9E190e0F92ce1',
  },
  USDC: {
    decimals: 6,
    id: 19,
    UNDERLYING: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    A_TOKEN: '0xBcca60bB61934080951369a648Fb03DF4F96263C',
    V_TOKEN: '0x619beb58998eD2278e08620f97007e1116D5D25b',
    INTEREST_RATE_STRATEGY: '0x013cDe9e76Fd7Cab355b9f884ad8EE4Ccb781278',
    ORACLE: '0x0B9a09cc52afc0d38ACcbd649aca1Da299d34454',
  },
  CRV: {
    decimals: 18,
    id: 20,
    UNDERLYING: '0xD533a949740bb3306d119CC777fa900bA034cd52',
    A_TOKEN: '0x8dAE6Cb04688C62d939ed9B68d32Bc62e49970b1',
    V_TOKEN: '0x00ad8eBF64F141f1C81e9f8f792d3d1631c6c684',
    INTEREST_RATE_STRATEGY: '0x35FE8C9924718f286463e659be35b4122eEe907F',
    ORACLE: '0x8a12Be339B0cD1829b91Adc01977caa5E9ac121e',
  },
  GUSD: {
    decimals: 2,
    id: 21,
    UNDERLYING: '0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd',
    A_TOKEN: '0xD37EE7e4f452C6638c96536e68090De8cBcdb583',
    V_TOKEN: '0x279AF5b99540c1A3A7E3CDd326e19659401eF99e',
    INTEREST_RATE_STRATEGY: '0xE85Bf1E770bc3dC52A25594C2c16059a01aA8406',
    ORACLE: '0xEc6f4Cd64d28Ef32507e2dc399948aAe9Bbedd7e',
  },
  BAL: {
    decimals: 18,
    id: 22,
    UNDERLYING: '0xba100000625a3754423978a60c9317c58a424e3D',
    A_TOKEN: '0x272F97b7a56a387aE942350bBC7Df5700f8a4576',
    V_TOKEN: '0x13210D4Fe0d5402bd7Ecbc4B5bC5cFcA3b71adB0',
    INTEREST_RATE_STRATEGY: '0x503eFA3651E247F9078C6F66bb93E2a81566EE00',
    ORACLE: '0xC1438AA3823A6Ba0C159CfA8D98dF5A994bA120b',
  },
  xSUSHI: {
    decimals: 18,
    id: 23,
    UNDERLYING: '0x8798249c2E607446EfB7Ad49eC89dD1865Ff4272',
    A_TOKEN: '0xF256CC7847E919FAc9B808cC216cAc87CCF2f47a',
    V_TOKEN: '0xfAFEDF95E21184E3d880bd56D4806c4b8d31c69A',
    INTEREST_RATE_STRATEGY: '0x6855E5544Cd803BF24c9612b3F12C009116B0ee1',
    ORACLE: '0xF05D9B6C08757EAcb1fbec18e36A1B7566a13DEB',
  },
  renFIL: {
    decimals: 18,
    id: 24,
    UNDERLYING: '0xD5147bc8e386d91Cc5DBE72099DAC6C9b99276F5',
    A_TOKEN: '0x514cd6756CCBe28772d4Cb81bC3156BA9d1744aa',
    V_TOKEN: '0x348e2eBD5E962854871874E444F4122399c02755',
    INTEREST_RATE_STRATEGY: '0x311C866D55456e465e314A3E9830276B438A73f0',
    ORACLE: '0x0606Be69451B1C9861Ac6b3626b99093b713E801',
  },
  RAI: {
    decimals: 18,
    id: 25,
    UNDERLYING: '0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919',
    A_TOKEN: '0xc9BC48c72154ef3e5425641a3c747242112a46AF',
    V_TOKEN: '0xB5385132EE8321977FfF44b60cDE9fE9AB0B4e6b',
    INTEREST_RATE_STRATEGY: '0x7B3217A81D1ADe9B0666feA260228102E8105e99',
    ORACLE: '0x4ad7B025127e89263242aB68F0f9c4E5C033B489',
  },
  AMPL: {
    decimals: 9,
    id: 26,
    UNDERLYING: '0xD46bA6D942050d489DBd938a2C909A5d5039A161',
    A_TOKEN: '0x1E6bb68Acec8fefBD87D192bE09bb274170a0548',
    V_TOKEN: '0xf013D90E4e4E3Baf420dFea60735e75dbd42f1e1',
    INTEREST_RATE_STRATEGY: '0x6855E5544Cd803BF24c9612b3F12C009116B0ee1',
    ORACLE: '0x492575FDD11a0fCf2C6C719867890a7648d526eB',
  },
  USDP: {
    decimals: 18,
    id: 27,
    UNDERLYING: '0x8E870D67F660D95d5be530380D0eC0bd388289E1',
    A_TOKEN: '0x2e8F4bdbE3d47d7d7DE490437AeA9915D930F1A3',
    V_TOKEN: '0xFDb93B3b10936cf81FA59A02A7523B6e2149b2B7',
    INTEREST_RATE_STRATEGY: '0x6855E5544Cd803BF24c9612b3F12C009116B0ee1',
    ORACLE: '0x09e57964e9F314c61aA3614f9DdE037779Fc9ff1',
  },
  DPI: {
    decimals: 18,
    id: 28,
    UNDERLYING: '0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b',
    A_TOKEN: '0x6F634c6135D2EBD550000ac92F494F9CB8183dAe',
    V_TOKEN: '0x4dDff5885a67E4EffeC55875a3977D7E60F82ae0',
    INTEREST_RATE_STRATEGY: '0x23A6A30F7301607b9bf0a577b0DDBD07920260C7',
    ORACLE: '0x92A6A444f5b433235297d849d2F93B405657234a',
  },
  FRAX: {
    decimals: 18,
    id: 29,
    UNDERLYING: '0x853d955aCEf822Db058eb8505911ED77F175b99e',
    A_TOKEN: '0xd4937682df3C8aEF4FE912A96A74121C0829E664',
    V_TOKEN: '0xfE8F19B17fFeF0fDbfe2671F248903055AFAA8Ca',
    INTEREST_RATE_STRATEGY: '0x6855E5544Cd803BF24c9612b3F12C009116B0ee1',
    ORACLE: '0xfD4A67F3c42CCA8ab4De6fba35dc11ffc87EE65e',
  },
  FEI: {
    decimals: 18,
    id: 30,
    UNDERLYING: '0x956F47F50A910163D8BF957Cf5846D573E7f87CA',
    A_TOKEN: '0x683923dB55Fead99A79Fa01A27EeC3cB19679cC3',
    V_TOKEN: '0xC2e10006AccAb7B45D9184FcF5b7EC7763f5BaAe',
    INTEREST_RATE_STRATEGY: '0x77285e3CDD9a3CA67aEd9a3d7A3837bEbA0DBDdE',
    ORACLE: '0xac3AF0f4A52C577Cc2C241dF51a01FDe3D06D93B',
  },
  stETH: {
    decimals: 18,
    id: 31,
    UNDERLYING: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
    A_TOKEN: '0x1982b2F5814301d4e9a8b0201555376e62F82428',
    V_TOKEN: '0xA9DEAc9f00Dc4310c35603FCD9D34d1A750f81Db',
    INTEREST_RATE_STRATEGY: '0xff04ed5f7a6C3a0F1e5Ea20617F8C6f513D5A77c',
    ORACLE: '0xADE6CBA6c45aa8E9d0337cAc3D2619eabc39D901',
  },
  ENS: {
    decimals: 18,
    id: 32,
    UNDERLYING: '0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72',
    A_TOKEN: '0x9a14e23A58edf4EFDcB360f68cd1b95ce2081a2F',
    V_TOKEN: '0x176808047cc9b7A2C9AE202c593ED42dDD7C0D13',
    INTEREST_RATE_STRATEGY: '0x6855E5544Cd803BF24c9612b3F12C009116B0ee1',
    ORACLE: '0xd4641b75015E6536E8102D98479568D05D7123Db',
  },
  UST: {
    decimals: 6,
    id: 33,
    UNDERLYING: '0xa693B19d2931d498c5B318dF961919BB4aee87a5',
    A_TOKEN: '0xc2e2152647F4C26028482Efaf64b2Aa28779EFC4',
    V_TOKEN: '0xaf32001cf2E66C4C3af4205F6EA77112AA4160FE',
    INTEREST_RATE_STRATEGY: '0x7B3217A81D1ADe9B0666feA260228102E8105e99',
    ORACLE: '0x774a7BC8b395A3F9879197D21cF6e7c6a2639937',
  },
  CVX: {
    decimals: 18,
    id: 34,
    UNDERLYING: '0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B',
    A_TOKEN: '0x952749E07d7157bb9644A894dFAF3Bad5eF6D918',
    V_TOKEN: '0x4Ae5E4409C6Dbc84A00f9f89e4ba096603fb7d50',
    INTEREST_RATE_STRATEGY: '0x2c206fa2127aB7f1CE3dc987daf683Ed5B9CF069',
    ORACLE: '0xC9CbF687f43176B302F03f5e58470b77D07c61c6',
  },
  ONE_INCH: {
    decimals: 18,
    id: 35,
    UNDERLYING: '0x111111111117dC0aa78b770fA6A738034120C302',
    A_TOKEN: '0xB29130CBcC3F791f077eAdE0266168E808E5151e',
    V_TOKEN: '0xD7896C1B9b4455aFf31473908eB15796ad2295DA',
    INTEREST_RATE_STRATEGY: '0x6855E5544Cd803BF24c9612b3F12C009116B0ee1',
    ORACLE: '0x72AFAECF99C9d9C8215fF44C77B94B99C28741e8',
  },
  LUSD: {
    decimals: 18,
    id: 36,
    UNDERLYING: '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
    A_TOKEN: '0xce1871f791548600cb59efbefFC9c38719142079',
    V_TOKEN: '0x411066489AB40442d6Fc215aD7c64224120D33F2',
    INTEREST_RATE_STRATEGY: '0x7B3217A81D1ADe9B0666feA260228102E8105e99',
    ORACLE: '0xd44d9a2E4643d55c1FA503C01a6cbB874a48Ae2E',
  },
} as const;
